/*eslint-disable */
define(function(require) {
    var $                   = require('jquery');
    var Popup               = require('site/common/popup');

    var $popup = $('#signup-choice-popup');
    var popup = new Popup($popup, {
        width: 380
    });
    
    return function() {
        $popup.on('dialogclose', function() {
            $popup.off('dialogclose');
        });

        popup.open();
    };
});
